/**
 * Booking in one place, by program (1.8.3, D-1.8.3-3 — Elijah, 9 Oct 2026): "Booking lets me schedule housekeeping,
 * companion services, or any other service the Foundation offers, and it should be categorized."
 *
 * Book asks **what** as these five, in this order. Housekeeping and Tech Support continue as they always have;
 * Companion & Wellness and Reading & Services continue into the volunteer request for a tenant; Volunteer help needs
 * no tenant. The volunteer three are the office's (administrator and co-administrator — the same people who open
 * Volunteers); the scheduler is Housekeeping only (26 Oct 2026).
 */
import type { Role } from './roles';

export const BOOK_PROGRAMS = ['housekeeping', 'companion', 'reading', 'tech', 'volunteer-help'] as const;
export type BookProgram = (typeof BOOK_PROGRAMS)[number];

/** The three that go to volunteers (never offered to the scheduler, the crew or a viewer). */
export const VOLUNTEER_BOOK_PROGRAMS: readonly BookProgram[] = ['companion', 'reading', 'volunteer-help'];

export function bookProgramsFor(role: Role | null | undefined): BookProgram[] {
  if (role === 'admin' || role === 'coadmin') return [...BOOK_PROGRAMS];
  if (role === 'scheduler') return ['housekeeping']; // 26 Oct 2026 (D-1020-SMALL): Housekeeping only — the scheduler does not book Tech
  // 1.8.5 (D-1.8.5-2): the tech books Tech Support and nothing else
  if (role === 'tech') return ['tech'];
  return [];
}

/**
 * Where a button moved into Book, the old place says so for two weeks (Elijah's rule for 1.8.3). The line shows up to
 * and including this civil day (America/New_York) and then stops by itself.
 */
export const MOVED_NOTE_UNTIL = '20261024';

export function movedNoteShows(todayKey: string): boolean {
  return todayKey <= MOVED_NOTE_UNTIL;
}

/** Which volunteer program a Book choice asks for (the request sheet's service). */
export const REQUEST_SERVICE: Partial<Record<BookProgram, 'COMPANION' | 'READING'>> = { companion: 'COMPANION', reading: 'READING' };
